"use client";
import next_api from "@/http/next_api";
import { Link, useRouter } from "@/i18n/routing";
import { cn } from "@/lib/utils";
import { Loader2, LogInIcon, LogOut, User2Icon, UserIcon } from "lucide-react";
import { useTranslations } from "next-intl";
import { useState } from "react";

const AvatarComponent = () => {
  const translate = useTranslations('Header.user');
  const [isCollapsed, setIsCollapse] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const router = useRouter();

  return (
    <div
      onClick={() => setIsCollapse(!isCollapsed)}
      className="group relative bg-white dark:bg-black rounded-full  p-2  cursor-pointer "
    >
      <UserIcon className="group-hover:opacity-50 group-hover:scale-125 group-active:scale-75 group-active:opacity-75 transition-all" />
      <div
        className={cn(
          "absolute z-[999] text-center shadow-2xl text-black mt-3 bg-white w-auto right-0  top-full rounded-xl scale-y-100 origin-top  overflow-hidden transition-all ",
          isCollapsed && "scale-y-0"
        )}
      >
        <ul className="flex  [&>li:hover]:bg-black/30 [&>li]:transition-all [&>li]:p-2 [&>li]:flex [&>li]:items-center text-nowrap [&>li]:gap-2 flex-col gap-2">
          <li>
            <Link className="flex items-center gap-2" href="/profile">
              {" "}
              <User2Icon /> {translate('profile')}
            </Link>
          </li>{" "}
          <li
            onClick={async () => {
              setIsLoading(true);
              try {
                const res = await next_api.post("/logout");
                if (res.status === 200) {
                  router.push("/login");
                }
              } catch (error) {
                console.log(error);
              } finally {
                setIsLoading(false);
              }
            }}
          >
            {isLoading ? (
              <Loader2 className="animate-spin" />
            ) : (
              <>
                <LogOut /> {translate('logout')}
              </>
            )}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AvatarComponent;
